import { getAuthToken } from '../utils/auth';

const baseUrl = process.env.REACT_APP_API_BASE_URL?.replace(/\/$/, '') ?? '';

export async function uploadBannerImage(file: File): Promise<{ ok: boolean; url: string }> {
  const form = new FormData();
  form.append('file', file);
  form.append('prefix', 'banners');

  const token = getAuthToken();
  const res = await fetch(`${baseUrl}/files/upload`, {
    method: 'POST',
    body: form,
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || res.statusText);
  }

  const body = await res.json();
  const url = body?.url ?? body?.Location ?? body?.location ?? null;
  if (!url) {
    throw new Error('Upload succeeded but URL was not returned.');
  }

  return { ok: true, url };
}

